<template>
  <div>
    <PageTitle title="Reports" />
    <v-container fluid class="lighten-12 content">
      <v-card class>
        <v-tabs v-model="tab" background-color="primary" dark hide-slider>
          <v-tabs-slider></v-tabs-slider>
          <v-tab
            v-for="item in items"
            :key="item.tab"
            @click="closepdf"
            @change="clearFilter1"
          >
            {{ item.tab }}
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
          <!-- Product Reports -->
          <v-tab-item>
            <v-row>
              <v-col :cols="4">
                <v-tabs
                  class="my-vertical-tab"
                  vertical
                  v-model="tab4"
                  background-color="primary"
                  dark
                  grow
                  hide-slider
                >
                  <v-tabs-slider></v-tabs-slider>
                  <v-tab
                    v-for="(verticaltab, index2) in Products"
                    :key="verticaltab.tab"
                    @click="closepdf"
                    @change="clearFilter1"
                  >
                    {{ verticaltab.tab }}
                  </v-tab>
                </v-tabs>
              </v-col>

              <v-col :cols="8">
                <v-tabs-items v-model="tab4">
                  <v-tab-item>
                    <ProductsTab />
                  </v-tab-item>
                  <v-tab-item>
                    <SalesRevenue />
                  </v-tab-item>
                  <v-tab-item>
                    <SalesRevenue :ASC="true" />
                  </v-tab-item>
                  <v-tab-item>
                    <ProductPurchase />
                  </v-tab-item>
                </v-tabs-items>
              </v-col>
            </v-row>
          </v-tab-item>
          <v-tab-item>
            <v-row>
              <v-col :cols="4">
                <v-tabs
                  class="my-vertical-tab"
                  vertical
                  v-model="tab1"
                  background-color="primary"
                  dark
                  grow
                  hide-slider
                >
                  <v-tabs-slider></v-tabs-slider>
                  <v-tab
                    v-for="(verticaltab, index2) in items1"
                    :key="verticaltab.tab"
                    @click="closepdf"
                    @change="clearFilter1"
                  >
                    {{ verticaltab.tab }}
                  </v-tab>
                </v-tabs>
              </v-col>

              <v-col :cols="8">
                <v-tabs-items v-model="tab1">
                  <v-tab-item>
                    <PurchaseTab />
                  </v-tab-item>
                  <v-tab-item>
                    <PurchaseReturnTab />
                  </v-tab-item>
                  <v-tab-item>
                    <PurchaseOrderTab />
                  </v-tab-item>
                </v-tabs-items>
              </v-col>
            </v-row>
          </v-tab-item>
          <v-tab-item>
            <v-row>
              <v-col :cols="4">
                <v-tabs
                  v-model="tab2"
                  vertical
                  class="my-vertical-tab1"
                  background-color="primary"
                  dark
                  grow
                  hide-slider
                >
                  <v-tabs-slider></v-tabs-slider>
                  <v-tab
                    v-for="(verticaltab, index3) in items2"
                    :key="verticaltab.tab"
                    @click="closepdf"
                    @change="clearFilter1"
                  >
                    {{ verticaltab.tab }}
                  </v-tab>
                </v-tabs>
              </v-col>

              <v-col :cols="8">
                <v-tabs-items v-model="tab2">
                  <v-tab-item>
                    <LowStockTab />
                  </v-tab-item>
                  <v-tab-item>
                    <OutOfStockTab />
                  </v-tab-item>
                  <v-tab-item>
                    <DailyStocksCompare />
                  </v-tab-item>
                  <v-tab-item>
                    <DailyShopStockCompare />
                  </v-tab-item>
                </v-tabs-items>
              </v-col>
            </v-row>
          </v-tab-item>
          <v-tab-item>
            <SalesTab />
          </v-tab-item>
          <v-tab-item>
            <v-row>
              <v-col :cols="4">
                <v-tabs
                  v-model="tab3"
                  vertical
                  background-color="primary"
                  dark
                  grow
                  class="my-vertical-tab"
                  hide-slider
                >
                  <v-tabs-slider></v-tabs-slider>
                  <v-tab
                    v-for="(verticaltab, index3) in Customers"
                    :key="verticaltab.tab"
                    @click="closepdf"
                    @change="clearFilter1"
                  >
                    {{ verticaltab.tab }}
                  </v-tab>
                </v-tabs>
              </v-col>

              <v-col :cols="8">
                <v-tabs-items v-model="tab3">
                  <v-tab-item>
                    <CustomerTab />
                  </v-tab-item>
                  <v-tab-item>
                    <CustomerSalesTab />
                  </v-tab-item>
                  <v-tab-item>
                    <CustomerPaymentTab />
                  </v-tab-item>
                </v-tabs-items>
              </v-col>
            </v-row>
          </v-tab-item>
          <v-tab-item>
            <v-card height="100%">
              <v-row>
                <v-col :cols="4">
                  <v-tabs
                    v-model="tab5"
                    vertical
                    background-color="primary"
                    dark
                    grow
                    class="my-vertical-tab3"
                    hide-slider
                  >
                    <v-tabs-slider></v-tabs-slider>
                    <v-tab
                      v-for="(verticaltab, index4) in Suppliers"
                      :key="verticaltab.tab"
                      @click="closepdf"
                      @change="clearFilter1"
                    >
                      {{ verticaltab.tab }}
                    </v-tab>
                  </v-tabs>
                </v-col>

                <v-col :cols="8">
                  <v-tabs-items v-model="tab5">
                    <v-tab-item>
                      <SuppliersTab />
                    </v-tab-item>
                    <v-tab-item>
                      <SupplierProductsTab />
                    </v-tab-item>
                    <v-tab-item>
                      <SupplierPurchaseTab />
                    </v-tab-item>
                    <v-tab-item>
                      <SupplierPurchaseOrderTab />
                    </v-tab-item>
                    <v-tab-item>
                      <SupplierPurchaseReturnTab />
                    </v-tab-item>
                    <v-tab-item>
                      <SupplierPaymentsTab />
                    </v-tab-item>
                  </v-tabs-items>
                </v-col>
              </v-row>
            </v-card>
          </v-tab-item>
          <!-- Shop Reports -->
          <v-tab-item v-if="isChecked">
            <v-card height="100%">
              <v-row>
                <v-col :cols="4">
                  <v-tabs
                    v-model="tab6"
                    vertical
                    background-color="primary"
                    dark
                    grow
                    class="my-vertical-tab3"
                    hide-slider
                  >
                    <v-tabs-slider></v-tabs-slider>
                    <v-tab
                      v-for="(verticaltab, index6) in Shop"
                      :key="verticaltab.tab"
                      @click="closepdf"
                      @change="clearFilter1"
                    >
                      {{ verticaltab.tab }}
                    </v-tab>
                  </v-tabs>
                </v-col>

                <v-col :cols="8">
                  <v-tabs-items v-model="tab6">
                    <v-row>
                      <v-col cols="10" lg="10" md="10" sm="10"></v-col>
                      <v-col cols="2" lg="2" md="2" sm="2">
                        <div>
                          <toggle-button
                            v-model="isChecked"
                            :value="isChecked"
                            :width="84"
                            :height="23"
                            :labels="{
                              checked: 'Shop',
                              unchecked: 'Warehoues',
                            }"
                          ></toggle-button></div
                      ></v-col>
                    </v-row>

                    <v-tab-item>
                      <SalesReportPM />
                    </v-tab-item>
                    <v-tab-item>
                      <ProductTransferPM />
                    </v-tab-item>
                    <v-tab-item>
                      <ShopToShop />
                    </v-tab-item>
                    <v-tab-item>
                      <ShopStockPM />
                    </v-tab-item>
                  </v-tabs-items>
                </v-col>
              </v-row>
            </v-card>
          </v-tab-item>
          <!-- Warehouse Reports -->
          <v-tab-item v-else>
            <v-card height="100%">
              <v-row>
                <v-col :cols="4">
                  <v-tabs
                    v-model="tab6"
                    vertical
                    background-color="primary"
                    dark
                    grow
                    class="my-vertical-tab3"
                    hide-slider
                  >
                    <v-tabs-slider></v-tabs-slider>
                    <v-tab
                      v-for="(verticaltab, index4) in Warehouse"
                      :key="verticaltab.tab"
                      @click="closepdf"
                      @change="clearFilter1"
                    >
                      {{ verticaltab.tab }}
                    </v-tab>
                  </v-tabs>
                </v-col>

                <v-col :cols="8">
                  <v-tabs-items v-model="tab6">
                    <v-row>
                      <v-col cols="10" lg="10" md="10" sm="10"></v-col>
                      <v-col cols="2" lg="2" md="2" sm="2">
                        <div>
                          <toggle-button
                            v-model="isChecked"
                            :value="isChecked"
                            :width="84"
                            :height="23"
                            :labels="{
                              checked: 'Shop',
                              unchecked: 'Warehouse',
                            }"
                          ></toggle-button></div
                      ></v-col>
                    </v-row>
                    <v-tab-item>
                      <PurchaseReportPM />
                    </v-tab-item>
                    <v-tab-item>
                      <PurchaseOrderPM />
                    </v-tab-item>
                    <v-tab-item>
                      <PurchaseReturnReportPM />
                    </v-tab-item>
                    <v-tab-item>
                      <WarehouseStockReportPM />
                    </v-tab-item>
                  </v-tabs-items>
                </v-col>
              </v-row>
            </v-card>
          </v-tab-item>
          <!-- Cheque Reports -->
          <v-tab-item>
            <ChequesTab />
          </v-tab-item>
          <!-- Reports OverView -->
          <v-tab-item>
            <ReportOverViewTab />
          </v-tab-item>
        </v-tabs-items>
      </v-card>
      <div>
        <v-progress-linear
          v-if="LoadingBar"
          color="cyan"
          indeterminate
        ></v-progress-linear>
      </div>
      <v-btn
        ref="showBtn"
        @click="goto('document-section')"
        v-show="false"
      ></v-btn>
      <div id="document-section">
        <ProductListPdf
          v-if="iSPdfShow"
          :headers="Columnheaders"
          :items="StoreDatas"
          :filterDats="mapFilterdatas()"
          :modulename="modulename"
          :purchaseTotal="purchaseTotal"
          :discountTotal="discountTotal"
          :purchasePaid="purchasePaid"
          :salesTotal="salesTotal"
          :salesNet="salesNet"
          :shopVisible="isChecked"
          :salesDiscount="salesDiscount"
          :noDataVisible="isShowNoData"
        />
      </div>
    </v-container>
  </div>
</template>

<script>
import { mapState } from 'vuex';

// Components
import ProductListPdf from './PDF/ProductsList.vue';
import PurchaseOrderTab from './PurchaseOrderReportComponent.vue';
import ProductsTab from './ProductReportComponent.vue';
import SalesTab from './SalesReportComponent.vue';
import ProductPurchase from './PurchaseStockReport.vue';

import OutOfStockTab from './OutofStockReportComponent.vue';
import LowStockTab from './LowStockReportComponent.vue';
import PurchaseTab from './PurchaseReportComponent.vue';
import PurchaseReturnTab from './PurchaseReturnReportComponent.vue';
import PageTitle from '@/components/shared/PageTitle';
import CustomerTab from './CustomerReport.vue';
import CustomerSalesTab from './CustomerSalesReport.vue';
import CustomerPaymentTab from './CustomerPaymentReport.vue';
import SalesRevenue from './SalesRevenueReports.vue';
import SuppliersTab from './SupplierReportComponent.vue';
import SupplierProductsTab from './SupplierProductsReport.vue';
import SupplierPurchaseTab from './SupplierPurchaseReport.vue';
import SupplierPurchaseOrderTab from './SupplierPurchaseOrderReport.vue';
import SupplierPurchaseReturnTab from './SupplierPurchaseReturnReport.vue';
import SupplierPaymentsTab from './SupplierPaymentsReport.vue';
import DailyStocksCompare from '../../modules/Reports/DailyStocksCompare.vue';
import DailyShopStockCompare from '../../modules/Reports/DailyShopStockCompare.vue';
import PurchaseOrderPM from './Product Management/PurchaseOrderReportComponent.vue';
import PurchaseReportPM from './Product Management/PurchaseReportComponent.vue';
import PurchaseReturnReportPM from './Product Management/PurchaseReturnReportComponent.vue';
import WarehouseStockReportPM from './Product Management/WarehouseStockReportComponent.vue';
import ShopStockPM from './Product Management/ShopStockReportComponent.vue';
import ProductTransferPM from './Product Management/ProductTransferReportComponent.vue';
import SalesReportPM from './Product Management/SalesReportComponent.vue';
import ShopToShop from './Product Management/ShopToShopTransferReport.vue';
import ChequesTab from './Cheques/ChequesAllReport.vue';
import ReportOverViewTab from './Report Overview/index.vue';

export default {
  data: () => ({
    toggle_exclusive: undefined,
    isChecked: false,
    Suppliers: [
      { tab: 'Suppliers', content: '' },
      { tab: 'Products', content: '' },
      { tab: 'Purchase', content: '' },
      { tab: 'Purchase Order', content: '' },
      { tab: 'Purchase Return', content: '' },
      { tab: 'Payments', content: '' },
    ],

    Shop: [
      { tab: 'Sales', content: '' },
      { tab: 'Warehouse to Shop', content: '' },
      { tab: 'Shop to Shop', content: '' },
      { tab: 'Shop Stock', content: '' },
    ],

    Warehouse: [
      { tab: 'Purchase', content: '' },
      { tab: 'Purchase Order', content: '' },
      { tab: 'Purchase Return', content: '' },
      { tab: 'Warehouse Stock', content: '' },
    ],
    Products: [
      { tab: 'Products', content: '' },
      { tab: 'Top Revenue', content: '' },
      { tab: 'Low Revenue', content: '' },
      { tab: 'Item Purchase stock', content: '' },
    ],
    items2: [
      { tab: 'Low Stock', content: '' },
      { tab: 'Out Of Stock', content: '' },
      { tab: 'Daily Warehouse Stock', content: '' },
      { tab: 'Daily Shop Stock', content: '' },
    ],
    items1: [
      { tab: 'Purchase', content: '' },
      { tab: 'Purchase Return', content: '' },
      { tab: 'Purchase Order', content: '' },
    ],
    Customers: [
      { tab: 'List', content: '' },
      { tab: 'Sales', content: '' },
      { tab: 'Payments', content: '' },
    ],
    items: [
      { tab: 'Product', content: '' },
      { tab: 'Purchase', content: '' },
      { tab: 'Stock', content: '' },
      { tab: 'Sales', content: '' },
      { tab: 'Customer', content: '' },
      { tab: 'Suppliers', content: '' },
      { tab: 'Product Management', content: '' },
      { tab: 'Cheques', content: '' },
      { tab: 'Reports Overview', content: '' },
    ],
    tab: '',
    tab1: '',
    tab2: '',
    tab3: '',
    tab4: '',
    tab5: '',
    tab6: '',
  }),

  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },

  components: {
    PageTitle,
    ProductsTab,
    PurchaseTab,
    PurchaseReturnTab,
    ProductListPdf,
    PurchaseOrderTab,
    OutOfStockTab,
    LowStockTab,
    SalesTab,
    CustomerTab,
    CustomerSalesTab,
    CustomerPaymentTab,
    SalesRevenue,
    SuppliersTab,
    SupplierProductsTab,
    SupplierPurchaseTab,
    SupplierPurchaseOrderTab,
    SupplierPurchaseReturnTab,
    SupplierPaymentsTab,
    ProductPurchase,
    DailyStocksCompare,
    DailyShopStockCompare,
    PurchaseOrderPM,
    PurchaseReportPM,
    PurchaseReturnReportPM,
    WarehouseStockReportPM,
    ShopStockPM,
    ProductTransferPM,
    SalesReportPM,
    ShopToShop,
    ChequesTab,
    ReportOverViewTab,
  },
  computed: {
    ...mapState(['modulename']),
    ...mapState(['iSPdfShow']),
    ...mapState(['Columnheaders']),
    ...mapState(['StoreDatas']),
    ...mapState(['filterDatas']),
    ...mapState(['LoadingBar']),
    ...mapState(['purchaseTotal']),
    ...mapState(['discountTotal']),
    ...mapState(['purchasePaid']),
    ...mapState(['salesTotal']),
    ...mapState(['salesNet']),
    ...mapState(['salesDiscount']),
  },
  watch: {
    iSPdfShow: {
      handler(val) {
        this.goToTable();
      },
      deep: true,
    },

    StoreDatas(value) {
      if (value.length === 0) {
        this.isShowNoData = true;
      } else {
        this.isShowNoData = false;
      }
    },
  },
  created() {
    this.$store.commit('REMOVE_FILTERDATAS');
    this.$store.commit('UPDATE_IS_NEW_PAGE', false); // should run these 3 funcions when tab changed
    this.$store.commit('UPDATE_PAGINATION_PAGE_SIZE', 15);
  },
  methods: {
    mapFilterdatas() {
      return [
        {
          name: 'Brand',
          value: this.filterDatas.brandquery
            ? this.filterDatas.brandquery
            : null,
        },
        {
          name: 'Category',
          value: this.filterDatas.categoryquery
            ? this.filterDatas.categoryquery
            : null,
        },
        {
          name: 'Product',
          value: this.filterDatas.productquery
            ? this.filterDatas.productquery
            : null,
        },
        {
          name: 'Warehouse',
          value: this.filterDatas.warehousequery
            ? this.filterDatas.warehousequery
            : null,
        },
        {
          name: 'Expense',
          value: this.filterDatas.expnseCategoryquery
            ? this.filterDatas.expnseCategoryquery
            : null,
        },
        {
          name: 'Supplier',
          value: this.filterDatas.supplierquery
            ? this.filterDatas.supplierquery
            : null,
        },
        {
          name: 'Shop',
          value: this.filterDatas.shopquery ? this.filterDatas.shopquery : null,
        },
        {
          name: 'Customer',
          value: this.filterDatas.customerquery
            ? this.filterDatas.customerquery
            : null,
        },
        {
          name: 'biller',
          value: this.filterDatas.billerquery
            ? this.filterDatas.billerquery
            : null,
        },
        {
          name: 'StockTransfer Warehouse',
          value: this.filterDatas.StockTransferWarehouseQuery
            ? this.filterDatas.StockTransferWarehouseQuery
            : null,
        },
        {
          name: 'Date',
          value:
            (this.filterDatas.start ? this.filterDatas.start + ' - ' : '') +
            (this.filterDatas.end ? this.filterDatas.end : ''),
        },
        {
          name: 'Total Greater than',
          value: this.filterDatas.amount ? this.filterDatas.amount : null,
        },
        {
          name: 'Status',
          value: this.filterDatas.status ? this.filterDatas.status : null,
        },
        {
          name: 'Customer Type',
          value: this.filterDatas.customerTypequery
            ? this.filterDatas.customerTypequery
            : null,
        },

        {
          name: 'Cheque Status',
          value: this.filterDatas.cheqStatus
            ? this.filterDatas.cheqStatus
            : null,
        },

        {
          name: 'Cheque For',
          value: this.filterDatas.cheqFor ? this.filterDatas.cheqFor : null,
        },
      ];
    },
    closepdf() {
      this.$store.commit('UPDATE_PDF_VISIBLE', false);
      this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', false);
    },
    goToTable() {
      if (this.iSPdfShow == true) {
        setTimeout(() => {
          this.$refs.showBtn.$el.click();
        }, 200);
      }
    },
    goto(id) {
      var element = document.getElementById(id);
      element.scrollIntoView({ behavior: 'smooth' });
    },
    clearFilter1() {
      if (this.filterDatas.isrouteNewPage == false) {
        this.$store.commit('REMOVE_FILTERDATAS');
      }
      this.clearFilter;
      this.filter = {
        category: '',
        search: '',
        brand: '',
        paymenType: '',
        type: '',
        status: '',
        start: '',
        startDate: '',
        end: '',
        product: '',
        amount: '',
        damage: '',
        paymentStatus: '',
        payment: '',
        transferStatus: '',
        warehouse: '',
        shop: '',
        saleType: '',
        biller: '',
        purchaseStatus: '',
        customerType: '',
        purchaseOrderStatus: '',
        customerGroup: '',
        cheqStatus: '',
        expenseFor: '',
        incomeFor: '',
        toShop: '',
        fromShop: '',
        expenseCategory: '',
        date: '',
        ledger: '',
      };
    },
  },
};
</script>

<style>
.my-vertical-tab .v-slide-group__wrapper {
  height: 150px;
  overflow: auto;
}
.my-vertical-tab1 .v-slide-group__wrapper {
  height: 120px;
  overflow: auto;
}
.my-vertical-tab3 .v-slide-group__wrapper {
  height: 150px;
  overflow: auto;
}
</style>
